import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-12 d-flex justify-content-center col-md-4 d-md-block" }
const _hoisted_2 = { class: "floating-card" }
const _hoisted_3 = { class: "floating-card-inner rounded-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "floating-card-header" }, [
  /*#__PURE__*/_createElementVNode("span", {
    "aria-hidden": "true",
    class: "flycon flycon-start flycon-32 flycon-share-alt text-success ps-0",
    "data-v-795b1ca8": ""
  }, "­")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "floating-card-body" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Diese Maßnahme im Dokumentationstool öffnen")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "floating-card-footer pt-1"
}
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (_ctx.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                class: "btn btn-primary rounded-pill font-bold",
                href: _ctx.getDocutoolPath(),
                target: "_blank"
              }, "Im Doku-Tool öffnen", 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}